import { render, staticRenderFns } from "./VeDienTuFormCreate.vue?vue&type=template&id=28f82b49"
import script from "./VeDienTuFormCreate.vue?vue&type=script&lang=js"
export * from "./VeDienTuFormCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports